// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from '../ui/link';
import { use_siteicon } from '../ui/use_siteicon';
import './sitepic.module.less';
var Sitepic = props => {
  useTranslation();
  var activate = props.activate,
    title = props.title,
    link = props.link,
    is_generic = props.is_generic,
    requester = props.requester,
    more = props.more,
    on_get_more = props.on_get_more,
    sitepic_class = props.sitepic_class,
    icon_sources = props.icon_sources,
    image = props.image,
    unblocking = props.unblocking,
    img_load_delay = props.img_load_delay,
    cls = props.cls,
    Promo = props.promo;
  var _use_siteicon = use_siteicon({
      link,
      img_load_delay,
      icon_sources,
      is_generic,
      requester
    }),
    icon_link = _use_siteicon.icon_link,
    loaded = _use_siteicon.loaded,
    on_icon_error = _use_siteicon.on_icon_error,
    on_icon_load = _use_siteicon.on_icon_load;
  if (Promo) return /*#__PURE__*/React.createElement("div", {
    className: "sitepic tile"
  }, /*#__PURE__*/React.createElement(Promo, null));
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    img_err = _useState2[0],
    set_img_err = _useState2[1];
  var on_img_error = event => {
    event.target.onerror = null;
    set_img_err(true);
  };
  var on_click = event => more ? on_get_more(event) : activate(event, props);
  var cls_final = cn('sitepic tile', unblocking && 'unblocking', more && 'sitepic-more', cls);
  var href = more ? '/access/popular' : '#';
  var site = (sitepic_class || '').replace('sitepic_', '');
  var protocol_img = image && image.indexOf('//') == 0 ? 'https:' : '';
  return /*#__PURE__*/React.createElement(Link, {
    className: cls_final,
    href: href,
    onClick: on_click,
    "data-clickid": "sitepic",
    "data-info": JSON.stringify({
      site
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "sitepic-screen"
  }, !img_err && /*#__PURE__*/React.createElement("img", {
    src: image ? protocol_img + image : image,
    onError: on_img_error,
    alt: "sitepic",
    className: "lazyload"
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('sitepic-icon', !loaded && 'loading')
  }, !more && /*#__PURE__*/React.createElement("img", {
    src: icon_link,
    onError: on_icon_error,
    onLoad: on_icon_load,
    alt: "sitepic",
    className: "lazyload"
  })), /*#__PURE__*/React.createElement("div", {
    className: "lock"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lock-shadow"
  }), /*#__PURE__*/React.createElement("div", {
    className: "lock-handle handle-left"
  }), /*#__PURE__*/React.createElement("div", {
    className: "lock-handle handle-right"
  }), /*#__PURE__*/React.createElement("div", {
    className: "lock-body"
  }), /*#__PURE__*/React.createElement("div", {
    className: "lock-dashes"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dash"
  }), /*#__PURE__*/React.createElement("div", {
    className: "dash"
  }), /*#__PURE__*/React.createElement("div", {
    className: "dash"
  }))), !!unblocking && /*#__PURE__*/React.createElement("div", {
    className: "load-spinner"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "spinner",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(250, 100, 0, 0.8",
    offset: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(250, 100, 0, 0.05",
    offset: "1"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "path",
    cx: "30",
    cy: "30",
    r: "25",
    fill: "none",
    stroke: "url(#grad)",
    strokeWidth: "4"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sitepic-title"
  }, title));
};
export { Sitepic };